export default function tabInterfaceInit() {
    var tabInterface = this,
        tm__fade = null,
        tmDur_tab_fade = 300,
        tm_tabToggle = null,
        tmDur_tabToggle = 30;

    tabInterface.tabOpen = function (tabIndex) {
        var $target = $('[data-box-index=' + tabIndex + ']'),
            target_group = $target.data('togglable-group');
        this.activeTab = $target;

        /*clearTimeout(tm__fade);
         clearTimeout(tm_tabToggle);*/

        $('[data-box-togglable][data-togglable-group=' + target_group + ']').not($target).addClass('_fade');

        $('[data-toggle-box]').toggleClass('_active', false);

        /*tm__fade=*/
        setTimeout(function () {
            $('[data-box-togglable][data-togglable-group=' + target_group + ']').not($target).removeClass('_active');

            $('[data-toggle-box=' + tabIndex + ']').addClass('_active');
            $target.addClass('_active');

            /*tm_tabToggle=*/
            setTimeout(function () {
                $target.removeClass('_fade');
                $target.trigger('tab:shown');
            }, tmDur_tabToggle);

        }, tmDur_tab_fade);
    };

    tabInterface.tabHide = function (tabIndex) {
        var $target = $('[data-box-index=' + tabIndex + ']');

        clearTimeout(tm__fade);
        clearTimeout(tm_tabToggle);

        $target.addClass('_fade');

        tm__fade = setTimeout(function () {
            $target.removeClass('_active');
            $target.trigger('tab:hidden');
        }, tmDur_tab_fade);
    };

    $('body').on('click', '[data-toggle-box]', function () {
        var $this = $(this);
        if ($this.data('toggle-disabled') != 'disabled') {
            tabInterface.tabOpen($this.data('toggle-box'));
        }
    });

    $('body').on('tabShown', '[data-heading-text]', function () {
        var $this = $(this);
        $('[data-box-text][data-box-group=' + $this.data('togglable-group') + ']').text($this.data('heading-text'));
    });

    $('[data-box-autoshow]').each(function () {
        tabInterface.tabOpen($(this).data('box-index'));
    });
}